























import { Vue, Component } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { Todo, TodoStore } from "@/types/todo";

const TodoModule = namespace("todo");

@Component
export default class TodoFooter extends Vue {
  routes: { name: string; label: string }[] = [
    {
      name: "all",
      label: "All"
    },
    {
      name: "active",
      label: "Active"
    },
    {
      name: "completed",
      label: "Completed"
    }
  ];

  @State(state => state.todo.todoList)
  todoList!: Todo[];

  @TodoModule.Getter
  activeList!: Todo[];

  @TodoModule.Mutation("REMOVE_COMPLETED_TODO")
  removeCompletedTodo!: TodoStore.CommitRemoveCompletedTodo;

  get remaining(): number {
    return this.activeList.length;
  }

  onRemoveCompleted() {
    this.removeCompletedTodo();
  }
}
